import * as undoActions from 'owa-mail-undo';
import datapoints from './datapoints';
import flagItemService from 'owa-mail-store/lib/services/flagItemService';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import setRowsFlagStateHelper from './helpers/setRowsFlagStateHelper';
import strings from 'owa-strings/owa-mail-strings';
import { action } from 'satcheljs/lib/legacy';
import { getRowIdsFromRowKeys } from 'owa-mail-list-store';
import { handleServiceError } from 'owa-service-error';
import { userMailInteractionAction } from 'owa-mail-actions';
import { selectMailStoreItemById } from 'owa-mail-store';
import flagItemsStoreUpdate from 'owa-mail-actions/lib/triage/flagItemsStoreUpdate';
var SetItemsFlagStateActionName = 'setItemsFlagState';
var setItemsFlagStateInternal = action(SetItemsFlagStateActionName, datapoints.setItemsFlagStateDatapoint)(function setItemsFlagStateInternal(itemIds, instrumentationContexts, flagStatusToApply, parentFolderId) {
    undoActions.clearLastUndoableAction();
    var itemContexts = itemIds.map(function (itemIdValue) {
        var item = selectMailStoreItemById(itemIdValue);
        return {
            itemId: itemIdValue,
            conversationId: item.ConversationId.Id,
        };
    });
    handleServiceError(SetItemsFlagStateActionName, flagStatusToApply == 'Flagged'
        ? strings.errorMarkingItemAsFlag
        : strings.errorMarkingItemAsUnFlag, function () {
        // Dispatch action to update the store state
        flagItemsStoreUpdate(itemContexts, flagStatusToApply, parentFolderId);
        var instrumentationFlag;
        switch (flagStatusToApply) {
            case 'Flagged':
                instrumentationFlag = 'Flag';
                break;
            case 'NotFlagged':
                instrumentationFlag = 'FlagCleared';
                break;
            case 'Complete':
                instrumentationFlag = 'FlagComplete';
                break;
        }
        userMailInteractionAction(instrumentationFlag, instrumentationContexts);
        return flagItemService(itemIds, flagStatusToApply);
    });
});
/**
 * Set the specified flag state on a collection of items in listview table
 * @param itemRowKeys - the item row keys
 * @param tableViewId - the table view the conversations are in
 * @param flagType - the specified flag type to set
 */
export function setItemsFlagStateFromTable(itemRowKeys, instrumentationContexts, tableViewId, flagStatusToApply) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    setRowsFlagStateHelper(itemRowKeys, tableViewId, flagStatusToApply, function (rowKeys, flagStatusToApply) {
        var rowIdStrings = getRowIdsFromRowKeys(rowKeys, tableViewId);
        setItemsFlagStateInternal(rowIdStrings, instrumentationContexts, flagStatusToApply, tableView.tableQuery.folderId);
    });
}
export function setItemsFlagStateFromItemIds(itemIds, instrumentationContexts, flagStatusToApply, parentFolderId) {
    // Filter by existence in the item cache
    var filteredItemIds = itemIds.filter(function (itemId) { return !!selectMailStoreItemById(itemId); });
    if (filteredItemIds.length > 0) {
        setItemsFlagStateInternal(filteredItemIds, instrumentationContexts, flagStatusToApply, parentFolderId);
    }
}
//# sourceMappingURL=setItemsFlagState.js.map